import { handleTrack } from '../../../../../utils/tracker';
import { appendOrCreateQueryParam } from '../../../../Header/utils';
import { RightArrow } from '../../../../Icons/rightArrow/RightArrow';
import {
  ITR_UTM_REF,
  startFilingLink,
  startFilingLinkViewPlans,
} from '../../../../income-tax/static/data';
import { setITRLocalStorage } from '../../../../itr2/static/utils';
import { navigationCtx } from '../../context';
import { ISection } from '../../nav-section';
import { INavigatorVariant } from '../../types';
import { scrollIntoView } from '../../utils';

export const SubNavigation: React.FC<INavigatorVariant> = ({
  className = '',
  scrollOffset = 0,
  isVariant,
  refValue = ``,
}) => {
  const fileNowButtonText = 'File Now';
  const trackLabel = 'sec-navbar-link';
  const filingLink = isVariant ? startFilingLinkViewPlans : startFilingLink;
  const fileNowBtnLink = appendOrCreateQueryParam(
    filingLink,
    'utm_ref',
    refValue ? refValue : `${ITR_UTM_REF}_${trackLabel}_${fileNowButtonText}`
  );

  const { sections, activeSection, setActiveSectionCB, setJustScrolledCB } =
    navigationCtx();

  const handleClick = (
    e: React.MouseEvent | React.TouchEvent,
    id: string,
    element: HTMLDivElement
  ) => {
    e.preventDefault();
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    handleTrack({ label: trackLabel, obj: e.target });
  };

  return (
    <nav
      className={`w-full max-w-screen-xl px-[135px] mx-auto overflow-hidden lg:mx-auto md:px-5 lg:px-6 sm:px-0 ${className}`}
    >
      <div className="bg-[#F3F8FF] flex items-center justify-between rounded-sm border border-[#E0EDFE] overflow-auto">
        <div
          className=" text-font-200 font-medium whitespace-nowrap text-s-14 py-4 sticky left-0 bg-[#F3F8FF] cursor-pointer"
          onClick={(e) => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            handleTrack({ label: trackLabel, obj: e.target });
          }}
        >
          <span className="md:hidden sm:hidden pl-6 pr-3 border-r-xs border-[#D9D9D9]">
            ITR FILING
          </span>
          <span className="hidden md:block px-4 sm:block border-r-xs border-[#D9D9D9]">
            ITR
          </span>
        </div>

        <ul className={`flex items-center justify-center`}>
          {sections.map((section) => {
            const sectionProps: {
              onClick: () => void;
            } & ISection = section.props;
            const { id, name, onClick } = sectionProps;
            return (
              <li
                onClick={(e) => {
                  handleClick(e, id, section.ref.current as HTMLDivElement);
                  typeof onClick === 'function' && onClick();
                }}
                key={id}
                className={`text-s-14 cursor-pointer px-5 py-4 border-b-md whitespace-nowrap font-medium ${
                  id === activeSection
                    ? 'text-blue-350 border-blue-350'
                    : 'text-font-500 border-b-transparent'
                }`}
              >
                {name}
              </li>
            );
          })}
        </ul>
        <a
          href={fileNowBtnLink}
          rel="noreferrer"
          className="text-s-14 text-blue-350 whitespace-nowrap px-6 my-2 leading-[22px] font-medium flex items-center gap-2"
          onClick={(e) => {
            setITRLocalStorage(fileNowBtnLink);
            handleTrack({ label: trackLabel, obj: e.target });
          }}
        >
          {fileNowButtonText} <RightArrow />
        </a>
      </div>
    </nav>
  );
};
